export default __webpack_public_path__ + "img/chaomkTg.4c829b6c.svg";